var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`progress-bar-molecule is--variant-${_vm.variant}`},[_c('div',{staticClass:"progress",style:({
      width: `${_vm.progressPercentage}%`,
      backgroundColor: _vm.progressColor,
    })}),_vm._v(" "),(_vm.progressBarText)?_c('EsyParagraph',{staticClass:"progress-bar-text"},[_vm._v("\n    "+_vm._s(_vm.progressBarText)+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }